import { useCallback, useLayoutEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { useTimeout } from '@sierralabs/core-ui';
// get width and height of element
export function useElementSize(props) {
    const { once = false, elementRef } = props;
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    const [observer, setObserver] = useState();
    const [debounceUpdate, clearDebouncedUpdate] = useTimeout();
    // get size of container
    const getElementSize = useCallback(() => {
        if (!elementRef.current) {
            return [undefined, undefined];
        }
        const rect = elementRef.current.getBoundingClientRect();
        return [rect.width, rect.height];
    }, [elementRef]);
    const updateElementSize = useCallback(() => {
        const [width, height] = getElementSize();
        setWidth(width);
        setHeight(height);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getElementSize]);
    useLayoutEffect(() => {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        const ob = new ResizeObserver(() => {
            debounceUpdate(() => {
                if (!once || !(width && height)) {
                    updateElementSize();
                }
            }, 500);
        });
        setObserver(ob);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [once, width, height]);
    useLayoutEffect(() => {
        const el = elementRef.current;
        if (el && observer) {
            observer.observe(el);
            updateElementSize();
        }
        return () => {
            clearDebouncedUpdate();
            if (el) {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(el);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementRef, observer]);
    return [width, height];
}
//# sourceMappingURL=useElementSize.js.map